export const RES = {
  low: '1x',
  med: '2x',
  high: '3x',
};

export class Image {
  static getImage = (images, type) => images?.mobile?.[type];
}
